export default __webpack_public_path__ + "static/media/arrow-right-circle.b8ddefcf.svg";